export default function Popup({children, title, onClose}) {

	return (
		<div className="zapc-popup-container">
			<div className="zapc-popup-window">
				<div className="zapc-popup-header">
					<div className="zapc-popup-title">{title}</div>
					<button type="button" onClick={onClose}><i className="fa fa-times"></i></button>
				</div>
				<div className="zapc-popup-content">
					{children}
				</div>
			</div>
		</div>
	);
}